import * as React from "react";
import { useDispatch } from "@grandvisionhq/state";
import { useSetShippingMethod } from "../../../../../../../../hooks/operations/hooks/operations/use-set-shipping-method.js";
import { selectShippingMethod, toggleDeliveryAddress } from "../../../../../../../StepShipping/actions.js";
import { ShippingMethod } from "../../../../../../../../models/step-shipping/models/step-shipping/shipping-methods.js";
const useShippingMethodSelection = ({
  onError,
  onSuccess,
  shippingMethodList
}) => {
  const dispatch = useDispatch();
  const onShippingMethodError = React.useCallback(() => {
    onError && onError("MUTATION");
  }, [onError]);
  const handleOnShippingMethodSelectionCompleted = React.useCallback(
    (_, shippingMethodKey) => {
      dispatch(
        selectShippingMethod({
          shippingMethod: {
            method: shippingMethodKey,
            isValid: true,
            isTouched: true
          }
        })
      );
      onSuccess?.(shippingMethodKey);
    },
    [dispatch, onSuccess]
  );
  const { setShippingMethod, setSelectedShippingMethod } = useSetShippingMethod({
    onError: onShippingMethodError,
    onCompleted: handleOnShippingMethodSelectionCompleted
  });
  const handleChange = React.useCallback(
    async (method, globalStoreId) => {
      if (!shippingMethodList || shippingMethodList.length < 0) {
        throw new Error("No shipping methods available!");
      }
      const shippingMethod = shippingMethodList.find((item) => item.key === method);
      if (!shippingMethod) {
        console.warn("Partially unsupported shipping method selected, attempting to select it");
      } else {
        if (method === ShippingMethod.Pickup && !globalStoreId) {
          console.warn("Global Store ID is required for Pickup ");
          return;
        }
        setSelectedShippingMethod && setSelectedShippingMethod(method);
        if (method !== ShippingMethod.Delivery && method !== ShippingMethod.DeliveryExpress) {
          dispatch(toggleDeliveryAddress({ enabled: false }));
        }
        if (globalStoreId) {
          await setShippingMethod(shippingMethod?.id, globalStoreId);
        } else {
          await setShippingMethod(shippingMethod?.id);
        }
      }
    },
    [shippingMethodList, setSelectedShippingMethod, dispatch, setShippingMethod]
  );
  return {
    handleOnShippingMethodSelected: handleChange
  };
};
export {
  useShippingMethodSelection
};
//# sourceMappingURL=use-shipping-method-selection.js.map
